import { useMemo } from 'react'
import * as React from 'react'
import gql from 'graphql-tag'
import update from 'immutability-helper'
import styled from 'styled-components'
import {
  ChannelCard_ChannelFragment,
  useGqlRecommendChannelListMobileQuery,
} from 'generated/graphql'
import useIntersect from '@app.modules/hooks/useIntersect'
import ChannelCard from '../cards/ChannelCard/ChannelCard'
import ChannelCardLoading from '../cards/ChannelCard/ChannelCardLoading'

gql`
  query gqlRecommendChannelListMobile($first: Int, $after: String) {
    recommendChannelFeed(first: $first, after: $after) {
      totalCount
      nodes {
        ...channelCard_channel
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

// TODO: cursor기반 pagination 이 제공되면 무한 스크룰 적용 예정

const skeletonArr = ['', '', '', '', '', '', '', '', '', '']

const RecommendChannelListMobile: React.FC = () => {
  const { data, loading, error, fetchMore } =
    useGqlRecommendChannelListMobileQuery({
      variables: {
        first: 10,
      },
      fetchPolicy: 'cache-and-network',
    })

  const hasNextPage = useMemo(() => {
    if (!data) return null
    return data.recommendChannelFeed?.pageInfo.hasNextPage
  }, [data])

  const lastCursor = useMemo(() => {
    if (!data) return null
    return data.recommendChannelFeed?.pageInfo.endCursor
  }, [data])

  const handleIntersect = () => {
    // validation
    if (!hasNextPage || !lastCursor || loading) return

    const variables = {
      first: 10,
      after: lastCursor,
    }
    if (!fetchMore) return
    fetchMore({
      variables,
      updateQuery: (previousQueryResult, { fetchMoreResult }) => {
        if (!fetchMoreResult || !fetchMoreResult.recommendChannelFeed)
          return previousQueryResult
        const result = update(previousQueryResult, {
          recommendChannelFeed: {
            nodes: {
              $push: fetchMoreResult.recommendChannelFeed.nodes,
            },
            pageInfo: {
              $set: fetchMoreResult.recommendChannelFeed.pageInfo,
            },
          },
        })
        return result
      },
    })
  }

  const target = useIntersect(handleIntersect, [lastCursor, loading, fetchMore])

  return (
    <StyledWrapper>
      {(() => {
        // loading
        if (!data && loading)
          return (
            <>
              {skeletonArr.map((_, idx) => (
                <ChannelCardLoading key={idx} />
              ))}
            </>
          )
        // error
        if (error)
          return (
            <>
              {skeletonArr.map((_, idx) => (
                <ChannelCardLoading key={idx} />
              ))}
            </>
          )
        // view
        return (
          <>
            {data?.recommendChannelFeed.nodes
              .filter((el): el is ChannelCard_ChannelFragment => !!el)
              .map((channelCardData) => (
                <div
                  className="channel"
                  key={`RecommendChannelListMobile-${channelCardData.id}`}
                >
                  <ChannelCard enableNewBadge data={channelCardData!} />
                </div>
              ))}
          </>
        )
      })()}
      {hasNextPage && <div ref={target}></div>}
      {hasNextPage && <ChannelCardLoading />}
    </StyledWrapper>
  )
}

export default RecommendChannelListMobile

const StyledWrapper = styled.div`
  margin: 0 20px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  .nothing-content {
    font-size: 12px;
    padding: 15px 20px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;
    span {
      color: #01a0ff;
    }
  }
`
